import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleChartsModule } from 'angular-google-charts';
import { BLSRegionalStatisticsComponent, BLSReportComponent } from './bls.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		NgbModule,
		GoogleChartsModule
	],
	declarations: [
		BLSRegionalStatisticsComponent,
		BLSReportComponent
	],
	exports: [
		BLSRegionalStatisticsComponent,
		BLSReportComponent
	]
})
export class BLSComponentModule { }
